/** Max length for a user's username (stored as profiles.display_name). */
export const USERNAME_MAX_LENGTH = 15;

/**
 * Shortest password we let a user set. Mirrors `minimum_password_length` in
 * supabase/config.toml — the server rejects anything shorter, so a client that
 * disagreed would either send doomed requests or refuse passwords the server allows.
 */
export const MIN_PASSWORD_LENGTH = 8;

/**
 * The masked placeholder every password field shows. Derived from
 * MIN_PASSWORD_LENGTH so the three auth forms can't drift apart — and so the e2e
 * selector (PW_PLACEHOLDER in e2e/tests/helpers.ts, which can't import across
 * packages) has one source of truth to mirror.
 */
export const PASSWORD_PLACEHOLDER = '•'.repeat(MIN_PASSWORD_LENGTH);

/**
 * Whether open sign-up is advertised on the web marketing page. During the
 * private beta the landing CTAs show a disabled "Coming soon" instead of routing
 * to sign-up; only "Sign in" stays active. Account creation itself is gated by an
 * invite code in the beta-signup edge function.
 */
export const SIGNUP_OPEN = false;
